import Vue from 'vue'
import Vuex from 'vuex'
import cart from './modules/cart'
import airtimeproduct from './modules/airtimeproduct'
import alertmessage from './modules/alertmessage'
import login from './modules/login'
import VuexPersistence from 'vuex-persist'
import ProductGridModule from './modules/productGridModule'
import { getModule } from 'vuex-module-decorators'
import recepientDetailModule from './modules/recepientDetailModule'
import ShoppingCartModule from './modules/shoppingCart'
import OriginatorModule from './modules/originator'
import BookingModule from './modules/bookingModule'
import ProductModule from './modules/products'

Vue.use(Vuex)

export function Persist():boolean
{
  return localStorage.getItem('vuex')!==null
}

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    cart,
    login,
    airtimeproduct,
    alertmessage,
    productGridStore: ProductGridModule,
    recepientDetail:recepientDetailModule,
    product:ProductModule,
    booking:BookingModule,
    shoppingCart: ShoppingCartModule,
    originatorStore:OriginatorModule
  },
  plugins: [new VuexPersistence().plugin],
})

export default store;
